<template>
    <section>
        <div class="row">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'student/index' }">
                                Siswa
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            List Calon Siswa
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row px-3">
            <div class="col-12">
                <form v-on:submit.prevent="paginate(1, false)">
                    <div class="row mb-4 align-items-end">
                        <div class="col-xl-3 col-lg p-1" v-if="roleElligibleFilter()">
                            <label class="text-muted d-lg-flex d-none">Filter Cabang</label>
                            <select v-model="form.search.branchID" class="form-control form-control-sm">
                                <option value="">Pilih Cabang...</option>
                                <option v-for="branch in branches" v-bind:value="branch.id" v-bind:key="branch.id">{{ branch.name }}</option>
                            </select>
                        </div>
                        <div class="col-xl-3 col-lg p-1">
                            <label class="text-muted d-lg-flex d-none">Search</label>
                            <input v-model="form.search.keyword" class="form-control form-control-sm" placeholder="Search..." />
                        </div>
                        <div class="col-auto p-1">
                            <button type="submit" class="btn btn-danger btn-sm px-4">
                                Search
                            </button>
                        </div>
                        <div class="ml-auto col-auto p-1 text-right">
                            <router-link v-bind:to="{name: 'student/index'}" v-b-tooltip.hover title="Daftar siswa" class="btn btn-danger btn-sm">
                                Daftar Siswa
                            </router-link>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-auto p-1">
                            <label class="text-muted mr-3 mb-0">Filter Kelas</label>
                        </div>
                        <div class="col px-1">
                            <div v-for="grade in grades" v-bind:key="grade.id" class="form-check form-check-inline py-1">
                                <div class="custom-control custom-checkbox">
                                    <input v-model="form.search.gradeID" type="checkbox" class="custom-control-input" v-bind:value="grade.id" v-bind:id="'grade-' + grade.id" />
                                    <label class="custom-control-label" v-bind:for="'grade-' + grade.id">{{ grade.name }}</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-auto">
                            <button type="button" class="btn btn-sm btn-link" v-on:click="filterShow = !filterShow">
                                Column Filtering
                            </button>
                        </div>
                    </div>
                    <transition name="fade">
                        <div class="row mt-4" v-if="filterShow">
                            <div class="col">
                                <h4 class="text-danger mb-4">Pilih atribute yang ingin ditampilkan</h4>
                                <div class="row">
                                    <div class="col-12">
                                        <!-- Section 1 -->
                                        <div class="card shadow-sm mb-4 border-0">
                                            <div class="card-header background-primary">
                                                <div class="row">
                                                    <div class="col">
                                                        <span class="h4 font-weight-medium text-white mb-0">
                                                            Profil Siswa
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.name" type="checkbox" class="custom-control-input" id="filter-name" />
                                                        <label class="custom-control-label" for="filter-name">Nama Lengkap</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.email" type="checkbox" class="custom-control-input" id="filter-email" />
                                                        <label class="custom-control-label" for="filter-email">Alamat Email</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.schoolID" type="checkbox" class="custom-control-input" id="filter-school" />
                                                        <label class="custom-control-label" for="filter-school">Asal Sekolah</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.gradeID" type="checkbox" class="custom-control-input" id="filter-grade" />
                                                        <label class="custom-control-label" for="filter-grade">Prodi Sekolah</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.btaGradeID" type="checkbox" class="custom-control-input" id="filter-bta-grade" />
                                                        <label class="custom-control-label" for="filter-bta-grade">Prodi BTA</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0" v-for="attribute in ['tempat_lahir', 'tanggal_lahir', 'jenis_kelamin', 'alamat_rumah', 'kode_pos', 'nomor_telp_rumah', 'nomor_hp_siswa', 'kurikulum_sekolah']">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns[attribute]" type="checkbox" class="custom-control-input" v-bind:id="'filter-' + attribute" />
                                                        <label class="custom-control-label" v-bind:for="'filter-' + attribute">{{ humanize(attribute) }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <!-- Section 2 -->
                                        <div class="card shadow-sm mb-4 border-0">
                                            <div class="card-header background-primary">
                                                <div class="row">
                                                    <div class="col">
                                                        <span class="h4 font-weight-medium text-white mb-0">
                                                            Data Orang Tua Siswa
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="form-check form-check-inline py-1 pl-0" v-for="attribute in ['nama_ayah', 'nomor_hp_ayah', 'email_ayah', 'pekerjaan_ayah', 'nama_ibu', 'nomor_hp_ibu', 'email_ibu', 'pekerjaan_ibu']">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns[attribute]" type="checkbox" class="custom-control-input" v-bind:id="'filter-' + attribute" />
                                                        <label class="custom-control-label" v-bind:for="'filter-' + attribute">{{ humanize(attribute) }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <!-- Section 3 -->
                                        <div class="card shadow-sm mb-4 border-0">
                                            <div class="card-header background-primary">
                                                <div class="row">
                                                    <div class="col">
                                                        <span class="h4 font-weight-medium text-white mb-0">
                                                            Data Kepesertaan Siswa BTA
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.registeredAt" type="checkbox" class="custom-control-input" id="filter-registered-at" />
                                                        <label class="custom-control-label" for="filter-registered-at">Tanggal Daftar</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.branchID" type="checkbox" class="custom-control-input" id="filter-branch-id" />
                                                        <label class="custom-control-label" for="filter-branch-id">Cabang</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.ukuran_jaket" type="checkbox" class="custom-control-input" id="filter-ukuran_jaket" />
                                                        <label class="custom-control-label" for="filter-ukuran_jaket">Ukuran Jaket Khusus Kelas 12 & Alumni</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0" v-for="n in 3">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns['sekolah_impian_' + n]" type="checkbox" class="custom-control-input" v-bind:id="'filter-sekolah_impian_' + n" />
                                                        <label class="custom-control-label" v-bind:for="'filter-sekolah_impian_' + n">Sekolah/ Universitas Impian {{ n }}</label>
                                                    </div>
                                                </div>
                                                <div class="form-check form-check-inline py-1 pl-0">
                                                    <div class="custom-control custom-checkbox">
                                                        <input v-model="columns.productID" type="checkbox" class="custom-control-input" id="filter-product-id" />
                                                        <label class="custom-control-label" for="filter-product-id">Product</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-4">
                                    <div class="col-auto">
                                        <h4 class="text-danger p-2 mb-0">Jika Sudah, silakan</h4>
                                    </div>
                                    <div class="col">
                                        <button class="btn btn-danger btn-sm px-5" type="button" v-on:click="filterShow = false">Hide Column Filtering</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                </form>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-4">
                <div id="table-primary" class="table-responsive" v-dragscroll="!isMobile()">
                    <table class="table">
                        <thead>
                            <tr class="text-danger font-weight-bold">
                                <th scope="col" v-if="columns.name" name="name" style="min-width: 15rem;" v-on:click="sort">
                                    Nama Lengkap <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" v-if="columns.branchID" name="branchID" v-on:click="sort">
                                    Cabang <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" v-if="columns.email" name="email" v-on:click="sort">
                                    Email <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" v-if="columns.registeredAt" name="registeredAt" v-on:click="sort">
                                    Tanggal Daftar <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" v-if="columns.schoolID" name="schoolID" v-on:click="sort">
                                    Asal Sekolah <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" v-if="columns.gradeID" name="gradeID" v-on:click="sort">
                                    Kelas Sekolah <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" v-if="columns.btaGradeID" name="btaGradeID" v-on:click="sort">
                                    Kelas BTA <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col" v-if="columns.productID" name="productID" v-on:click="sort">
                                    Produk <i class="fa fa-chevron-down"></i>
                                </th>

                                <th scope="col" v-for="profileLabel in profileLabels" v-if="columns[profileLabel]" v-bind:name="profileLabel" v-on:click="sort">
                                    {{ renderProfileLabel(profileLabel) }} <i class="fa fa-chevron-down"></i>
                                </th>
                                <th scope="col">
                                    Action
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="shadow-sm" v-for="student in students" v-bind:key="student.userID">
                                <td v-if="columns.name">
                                    <router-link v-bind:to="{name: 'student/candidate/view', params: {id: student.userID}}" class="text-loading" v-if="student.user">{{ student.user.name }}</router-link>
                                </td>
                                <td v-if="columns.branchID">
                                    <span class="text-loading" v-if="student.branch">{{ student.branch.name }}</span>
                                </td>
                                <td v-if="columns.email">
                                    <span class="text-loading" v-if="student.user">{{ renderCheckBlank(student.user.email) }}</span>
                                </td>
                                <td v-if="columns.registeredAt">
                                    <span class="text-loading"><template v-if="student.registeredAt">{{ $moment(student.registeredAt, "YYYY-MM-DD").format('D MMMM YYYY') }}</template></span>
                                </td>
                                <td v-if="columns.schoolID">
                                    <span class="text-loading" v-if="student.school">{{ student.school.name }}</span>
                                </td>
                                <td v-if="columns.gradeID">
                                    <span class="text-loading" v-if="student.grade">{{ student.grade.name }}</span>
                                </td>
                                <td v-if="columns.btaGradeID">
                                    <span class="text-loading" v-if="student.btaGrade">{{ student.btaGrade.name }}</span>
                                </td>
                                <td v-if="columns.productID">
                                    <span class="text-loading" v-if="student.productID">{{ student.product.name }}</span>
                                </td>
                                <td v-for="profileLabel in profileLabels" v-if="columns[profileLabel]">
                                    <span v-bind:class="{'text-loading': typeof student.additionals[profileLabel] === typeof undefined}">{{ renderCheckBlank(renderProfileLabelValue(student, profileLabel)) }}</span>
                                </td>
                                <td class="text-center">
                                    <button type="button" class="btn btn-danger btn-sm px-3 m-1" v-on:click="reference = student; modal.accept = true">
                                        Terima
                                    </button>
                                    <button type="button" class="btn btn-outline-danger btn-sm px-3 m-1" v-on:click="reference = student; modal.reject = true">
                                        Tolak
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-12 mb-4">
                <nav class="float-right">
                    <paginate v-model="page" next-text="<i class='fa fa-chevron-right'></i>" prev-text="<i class='fa fa-chevron-left'></i>" v-bind:click-handler="paginate" v-bind:page-count="pageCount" container-class="pagination pagination-sm flex-wrap" page-class="page-item" prev-class="page-item" v-bind:next-class="'page-item'" page-link-class="page-link" prev-link-class="page-link" next-link-class="page-link" v-bind:hide-prev-next="true">
                    </paginate>
                </nav>
            </div>
        </div>

        <template v-if="reference">
            <b-modal v-model="modal.accept" v-on:hide="reference = null" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
                <template slot="modal-header">
                    <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                        Confirmation
                    </h4>
                </template>
                <div class="container">
                    <form v-on:submit.prevent="accept">
                        <div class="row">
                            <div class="col-12 mb-4">
                                <h4 class="font-weight-medium mb-2 text-center">Anda akan menerima calon siswa dengan data sebagai berikut</h4>

                                <div class="row mb-1 align-items-center">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted mb-0 h4 form-divider">
                                            Nama
                                        </label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <h4 class="font-weight-medium mb-0 py-1">
                                            {{ reference.name }}
                                        </h4>
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted mb-0 h4 form-divider">
                                            Prodi BTA
                                        </label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <h4 class="font-weight-medium mb-0 py-1">
                                            {{ reference.btaGrade.name }}
                                        </h4>
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted mb-0 h4 form-divider">
                                            Cabang
                                        </label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <h4 class="font-weight-medium mb-0 py-1">
                                            {{ reference.branch.name }}
                                        </h4>
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center">
                                    <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                        <label class="font-weight-medium text-muted mb-0 h4 form-divider required">
                                            Nomor Induk Siswa
                                        </label>
                                    </div>
                                    <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                        <input v-model="form.accept.identity" class="form-control form-control-sm" required />
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 text-center">
                                <button type="submit" class="btn btn-outline-danger btn-sm px-5">
                                    Terima
                                </button>
                                <button class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal.accept = false">
                                    Batal
                                </button>        
                            </div>
                        </div>
                    </form>
                </div>
            </b-modal>

            <b-modal v-model="modal.reject" v-on:hide="reference = null" modal-class="border-0" header-class="background-primary" v-bind:centered="true" v-bind:hide-footer="true">
                <template slot="modal-header">
                    <h4 class="container text-uppercase text-white font-weight-bold text-center mb-0">
                        Confirmation
                    </h4>
                </template>
                <div class="container">
                    <div class="row">
                        <div class="col-12 mb-4">
                            <h4 class="font-weight-medium mb-2 text-center">Anda akan menghapus calon siswa dengan data sebagai berikut</h4>

                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">
                                        Nama
                                    </label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <h4 class="font-weight-medium mb-0 py-1">
                                        {{ reference.name }}
                                    </h4>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">
                                        Prodi BTA
                                    </label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <h4 class="font-weight-medium mb-0 py-1">
                                        {{ reference.btaGrade.name }}
                                    </h4>
                                </div>
                            </div>
                            <div class="row mb-1 align-items-center">
                                <div class="col-lg-5 col-md-12 col-sm-5 p-1">
                                    <label class="font-weight-medium text-muted mb-0 h4 form-divider">
                                        Cabang
                                    </label>
                                </div>
                                <div class="col-lg-7 col-md-12 col-sm-7 px-1">
                                    <h4 class="font-weight-medium mb-0 py-1">
                                        {{ reference.branch.name }}
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 text-center">
                            <button class="btn btn-outline-danger btn-sm px-5" v-on:click="reject">
                                Tolak
                            </button>
                            <button class="btn btn-danger btn-sm px-5 ml-3" v-on:click="modal.reject = false">
                                Batal
                            </button>        
                        </div>
                    </div>
                </div>
            </b-modal>
        </template>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import { dragscroll } from 'vue-dragscroll';
    import Paginate from 'vuejs-paginate';

    export default {
        name: "StudentCandidateIndex",
        directives: {dragscroll},
        components: {
            Paginate
        },
        computed: mapState([
            'profile',
            'term'
        ]),
        watch: {
            profile() {
                this.fetchBranches();
            },
            term() {
                this.paginate(this.page);
            },
            branchProgramID(branchProgramID) {
                if (branchProgramID) {
                    this.axios.get(process.env.API_URL + '/pattern', {params: {branchProgramID: branchProgramID}}).then(response => {
                        this.patterns = response.data.data;
                    });
                } else {
                    this.patterns = [];
                }
            }
        },
        data() {
            return {
                form: {
                    search: {
                        branchID: '',
                        keyword: '',
                        gradeID: [],
                        sortColumn: 'name',
                        sortType: 'asc'
                    },
                    accept: {
                        identity: ''
                    }
                },
                columns: {
                    name: true, gradeID: true, btaGradeID: true, branchID: true, schoolID: true, email: true, registeredAt: true, productID: true,
                    tempat_lahir: false, tanggal_lahir: false, jenis_kelamin: false, alamat_rumah: false, kode_pos: false, nomor_telp_rumah: false, nomor_hp_siswa: false, kurikulum_sekolah: false,
                    nama_ayah: false, nomor_hp_ayah: false, pekerjaan_ayah: false, email_ayah: false, nama_ibu: false, nomor_hp_ibu: false, pekerjaan_ibu: false, email_ibu: false,
                    ukuran_jaket: false, sekolah_impian_1: false, sekolah_impian_2: false, sekolah_impian_3: false
                },
                modal: {accept: false, reject: false},
                reference: null,
                filterShow: false,
                branchProgramID: '',
                pageCount: 0,
                page: 1,
                branches: [],
                patterns: [],
                branchPrograms: [],
                grades: [],
                profileLabels: [],
                students: [
                    {user: {}, branch: {}, school: {}, grade: {}, btaGrade: {}, additionals: {}, product: {}},
                    {user: {}, branch: {}, school: {}, grade: {}, btaGrade: {}, additionals: {}, product: {}},
                    {user: {}, branch: {}, school: {}, grade: {}, btaGrade: {}, additionals: {}, product: {}},
                    {user: {}, branch: {}, school: {}, grade: {}, btaGrade: {}, additionals: {}, product: {}},
                    {user: {}, branch: {}, school: {}, grade: {}, btaGrade: {}, additionals: {}, product: {}},
                    {user: {}, branch: {}, school: {}, grade: {}, btaGrade: {}, additionals: {}, product: {}},
                    {user: {}, branch: {}, school: {}, grade: {}, btaGrade: {}, additionals: {}, product: {}},
                    {user: {}, branch: {}, school: {}, grade: {}, btaGrade: {}, additionals: {}, product: {}},
                    {user: {}, branch: {}, school: {}, grade: {}, btaGrade: {}, additionals: {}, product: {}},
                    {user: {}, branch: {}, school: {}, grade: {}, btaGrade: {}, additionals: {}, product: {}}
                ]
            };
        },
        methods: {
            accept() {
                this.axios.post(process.env.API_URL + '/student/accept/' + this.reference.userID, this.form.accept).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.paginate(this.page);
                        this.modal.accept = false;
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            reject() {
                this.axios.post(process.env.API_URL + '/student/delete/' + this.reference.userID).then(response => {
                    if (response.data.status) {
                        this.$toastr('success', response.data.message, 'Success');
                        this.paginate(this.page);
                        this.modal.reject = false;
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            paginate(page, scroll = true) {
                this.axios.get(process.env.API_URL + '/student', {params: Object.assign({}, this.form.search, {termID: this.term.id, unregistered: 1, page: page})}).then(response => {
                    this.students = response.data.data.data;
                    this.pageCount = response.data.data.total ? response.data.data.last_page : 0;

                    if (scroll) {
                        document.getElementById('table-primary').scrollIntoView();
                        var headerElement = document.getElementsByTagName('nav');
                        if (headerElement.length) {
                            window.scrollBy(0, headerElement[0].offsetHeight * -1);
                        }
                    }
                });
            },
            fetchBranches() {
                if (this.roleElligibleFilter()) {
                    this.axios.get(process.env.API_URL + '/branch').then(response => {
                        this.branches = response.data.data;
                    });
                }
            },
            guessBranchProgram(student) {
                var branchProgram = {};
                if (student.studentVerified) {
                    if (student.studentVerified.pattern) {
                        branchProgram = student.studentVerified.pattern.branchProgram;
                    } else if (student.studentVerified.intensiveSchedule) {
                        branchProgram = student.studentVerified.intensiveSchedule.branchProgram;
                    }
                }
                return branchProgram;
            },
            patternLabel(pattern) {
                return pattern.periods.map(period => {
                    return this.$moment.weekdays(period.day) + ' ' + this.$moment(period.start, "HH:mm:ss").format('HH.mm') + ' - ' + this.$moment(period.end, "HH:mm:ss").format('HH.mm');
                }).join(" | ");
            },
            humanize(string) {
                return string.replace(/[_]+/g, ' ').replace(/^[a-z]| [a-z]/g, function (character) {
                    return character.toUpperCase();
                });
            },
            renderProfileLabelValue(student, profileLabel) {
                var value = student.additionals[profileLabel];
                if (value) {
                    switch (profileLabel) {
                        default:
                            break;
                    }
                }
                return value;
            },
            renderProfileLabel(profileLabel) {
                switch (profileLabel) {
                    case 'sekolah_impian_1':
                        profileLabel = 'Sekolah/ Universitas 1';
                        break;
                    case 'sekolah_impian_2':
                        profileLabel = 'Sekolah/ Universitas 2';
                        break;
                    case 'sekolah_impian_3':
                        profileLabel = 'Sekolah/ Universitas 3';
                        break;
                    case 'ukuran_jaket':
                        profileLabel = 'Ukuran Jaket Khusus Kelas 12 & Alumni';
                        break;
                    case 'diterima_jalur':
                        profileLabel = 'Diterima Di Jalur';
                        break;
                    case 'diterima_univ':
                        profileLabel = 'Diterima Di Sekolah/Univ';
                        break;
                    default:
                        break;
                }
                return this.humanize(profileLabel);
            },
            renderCheckBlank(value) {
                return (value !== '' && value !== null) || typeof value === typeof undefined ? value : " ";
            },
            sort(event) {
                var column = event.currentTarget;
                var columnName = column.getAttribute("name");
                if (columnName) {
                    this.form.search.sortType = (this.form.search.sortColumn !== columnName || this.form.search.sortType !== 'asc') ? 'asc' : 'desc';
                    this.form.search.sortColumn = columnName;

                    document.querySelectorAll("table tr th[sort]").forEach(element => {
                        element.removeAttribute("sort");
                    });
                    column.setAttribute("sort", this.form.search.sortType);
                }
                this.paginate(1);
            },
            roleElligibleModified() {
                return this.profile.isAdmin || (this.profile.isEmployee && this.profile.employee.isBranchStaff);
            },
            roleElligibleFilter() {
                return this.profile.isAdmin || (this.profile.isEmployee && (this.profile.employee.isDirector || this.profile.employee.isManager));
            },
            isMobile() {
                return 'ontouchstart' in window || navigator.msMaxTouchPoints;
            }
        },
        created() {
            this.fetchBranches();

            this.axios.all([
                this.axios.get(process.env.API_URL + '/grade'),
                this.axios.get(process.env.API_URL + '/student/listAttributes')
            ]).then(this.axios.spread(function (responseGrade, responseProfileLabel) {
                this.grades = responseGrade.data.data;
                this.profileLabels = responseProfileLabel.data.data;
            }.bind(this)));
        },
        mounted() {
            this.paginate(1, false);
            document.title = 'List Student - ' + process.env.APP_NAME;
        }
    };
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active { transition: opacity .5s; }
    .fade-enter, .fade-leave-to { opacity: 0; }

    @media (min-width: 768px) {
        .table-responsive .table td:first-child, .table-responsive .table th:first-child { min-width: 8.2rem;}
        .table-responsive .table td.sticky:nth-child(2), .table-responsive .table th.sticky:nth-child(2) { z-index: 2; left: 8.2rem; top: auto; position: -webkit-sticky; position: sticky; }
    }
</style>


// WEBPACK FOOTER //
// src/components/student/candidate/Index.vue